var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sub-navigation',{on:{"change-sub-nav":_vm.changeSubNav}}),_c(_vm.subPage,{tag:"component",attrs:{"site-id":_vm.selectedSite.id,"site-info":_vm.selectedSite.info}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }